<template>
  <div v-if="authenticatedUser">
    <b-container>
      <div class="mt-5 mb-3 ml-0 mr-0 ">
        <b-card no-body>
          <b-card-header header-tag="nav">
            <b-nav v-show="selector" card-header tabs fill>
              <b-nav-item @click="showMyOrganisations" active>Organisations I've added</b-nav-item>
<!--              <b-nav-item @click="showPublicOrganisations">Public</b-nav-item>-->
              <b-nav-item class="text-right">
                <router-link class="btn btn-sm bg-orange pb-0 pt-0" :to="{name: 'organizationAdd'}">Add organisation</router-link>
              </b-nav-item>
            </b-nav>

<!--            <b-nav v-show="!selector" card-header tabs fill>-->
<!--              <b-nav-item @click="showMyOrganisations">Organisations I've added</b-nav-item>-->
<!--              <b-nav-item @click="showPublicOrganisations" active>Public</b-nav-item>-->
<!--              <b-nav-item class="text-right text-white">-->
<!--                  <router-link class="btn btn-sm bg-orange pb-0 pt-0" :to="{name: 'organizationAdd'}">Add organisation</router-link>-->
<!--              </b-nav-item>-->
<!--            </b-nav>-->
          </b-card-header>

          <b-card-body class="text-center">
            <!-- Own Organizations -->
            <OrganizationSection v-show="selector" id="my-organizations" :type="ownOrganizations"/>
            <!-- Public Organizations -->
            <OrganizationSection v-show="!selector" id="public-organizations" class="mb-3" :type="publicOrganizations"/>
          </b-card-body>
        </b-card>
      </div>
    </b-container>
  </div>
  <div v-else>
    <NoAccess></NoAccess>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OrganizationSection from '../components/organizations/OrganizationSection'
import NoAccess from '../components/NoAccess'

export default {
  name: 'Organizations',
  data () {
    return {
      selector: true,
      'publicOrganizations': 'PUBLIC',
      'ownOrganizations': 'OWN'
      // 'sharedOrganizations': 'SHARE'
    }
  },
  components: {
    OrganizationSection,
    NoAccess
  },
  computed: {
    ...mapGetters([
      'authenticatedUser'
    ])
  },
  methods: {
    showMyOrganisations () {
      this.selector = true
    },
    showPublicOrganisations () {
      this.selector = false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Organizations.vue